'use client'

import { CONSENT_SERVICES } from '@/lib/consent/consentConstants'
import { createContext, ReactNode, useContext, useState } from 'react'
import * as CookieConsent from 'vanilla-cookieconsent'

const { SERVICE_ANALYTICS_STORAGE, SERVICE_FUNCTIONALITY_STORAGE } =
  CONSENT_SERVICES

interface ConsentState {
  analyticsStorageAllowed: boolean
  functionalityStorageAllowed: boolean
}

interface ConsentContextType extends ConsentState {
  updateConsent: () => void
}

const ConsentContext = createContext<ConsentContextType | undefined>(undefined)

type ConsentProviderProps = {
  children: ReactNode
}

export function ConsentProvider({ children }: ConsentProviderProps) {
  const [consentState, setConsentState] = useState<ConsentState>({
    analyticsStorageAllowed: false,
    functionalityStorageAllowed: false,
  })

  const updateConsent = () => {
    const analyticsStorageAllowed = CookieConsent.acceptedService(
      SERVICE_ANALYTICS_STORAGE,
      'analytics',
    )
    const functionalityStorageAllowed = CookieConsent.acceptedService(
      SERVICE_FUNCTIONALITY_STORAGE,
      'functionality',
    )

    setConsentState({
      analyticsStorageAllowed,
      functionalityStorageAllowed,
    })
  }

  return (
    <ConsentContext.Provider
      value={{
        ...consentState,
        updateConsent,
      }}
    >
      {children}
    </ConsentContext.Provider>
  )
}

export function useConsent(): ConsentContextType {
  const context = useContext(ConsentContext)
  if (context === undefined) {
    throw new Error('useConsent must be used within a ConsentProvider')
  }
  return context
}
